import {
  useGetMembershipByIdAdmin,
  useGetMembershipsByUserId,
} from "api/useB2bMembershipQuery";
import { InsuranceInfoKey } from "core/types";
import { useUserHasRole } from "hooks/userHooks";
import { useTranslation } from "react-i18next";
import PatientItem from "./patientItem";

export const PatientInsuranceInfo = ({
  insuranceInfoKey,
  patientUserId,
}: {
  insuranceInfoKey: InsuranceInfoKey;
  patientUserId?: string | number;
}) => {
  const { t } = useTranslation();
  const isAdmin = useUserHasRole("Admin");

  // Admins use the admin endpoint, other staff (e.g. psychologists) look up by user id.
  // Both hooks skip the call when disabled or missing their id.
  const adminMembership = useGetMembershipByIdAdmin(
    insuranceInfoKey?.key as string,
    { enabled: isAdmin },
  );
  const userMemberships = useGetMembershipsByUserId(Number(patientUserId), {
    enabled: !isAdmin,
  });

  const query = isAdmin ? adminMembership : userMemberships;
  const membership = isAdmin
    ? adminMembership.data?.membership
    : userMemberships.data?.memberships.find(
        ({ membershipId }) => membershipId === insuranceInfoKey?.key,
      );

  let membershipInfo;
  let staffInfo;
  if (query.isFetching) {
    membershipInfo = t("FETCHING");
    staffInfo = t("FETCHING");
  } else if (query.isError) {
    membershipInfo = t("FAILED_FETCH");
    staffInfo = t("FAILED_FETCH");
  } else {
    membershipInfo = membership?.primaryOrganizationId;
    staffInfo = membership?.organizationName.includes("staff")
      ? t("YES")
      : t("NO");
  }

  return (
    <>
      <PatientItem
        title={t("INSURANCE_MEMBERSHIP_ID")}
        value={membershipInfo}
      />
      <PatientItem title={t("STAFF")} value={staffInfo} />
    </>
  );
};
